export { DispensaryOrderingDetailsController as DispensaryOrderingDetails } from './dispensary-ordering-details-controller';
